import {
  Fragment,
  ReactNode,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import { ListItem } from "../../../components/Header";
import DotsIcon from "../../../components/ui-icons/DotsIcon";
import FolderIcon from "../../../components/ui-icons/FolderIcon";
import { Menu, Transition } from "@headlessui/react";
import { twMerge } from "tailwind-merge";
import { Breadcrumbs } from "../../../components/Breadcrumb";
import WorksDocumentTable from "../../../components/tables/WorksDocumentTable.mobile";
import { FlexCol, FlexRow } from "../../../utils/flexLayouts";
import { StarIcon } from "@heroicons/react/24/outline";
import FavoriteTable from "../../../components/tables/FavoriteTable.mobile";
import { NavItemType } from "../../../layouts/DashboardLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getNavigation } from "../../../components/Sidebar";
import { Filter, Folder, FoldersType, Keys } from "./type";
import { useFoldersContext } from "../../../contexts/FolderContext";
import Loading from "src/components/Loading";
import { modifiedFavoriteFoldersList } from "src/modules/acadia/favorites/selectors";
import {
  deleteItem,
  getItems,
  getItemsIdle,
} from "src/modules/spItems/actions";
import {
  favoriteFiltersListName,
  favoriteFoldersListName,
  listFields,
  myDocumentsListName,
  myWorksDocumentsListName,
  ReplacedListName,
} from "src/api/config";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getTitleByObject } from "src/utils/getTitleByObject";

import { modifiedFavoriteFiltersList } from "src/modules/acadia/favorites/selectors/selectFavoriteFilters";
import { useFiltersContext } from "src/contexts/FilterContext";
import { setDocNavIntent } from "src/utils/docNavigationIntent";
import { setLocalItem } from "src/utils/localStorage";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import { selectJustDeletedItem } from "src/modules/spItems/selectors/selectGetJustDeletedItem";
import { selectNextPage } from "src/modules/spItems/selectors";
import { useGetSelect } from "src/hooks/redux-selectors";
import TGButton from "src/components/ui/TGButton";
import {ApprovedStatus, MyWorkDocumentsType} from "src/types/main";
import { pluralizeDocument } from "src/utils/string.utils";
import { keyMap } from "./data/keyMap";
import { getWorkDocumentsInfo } from "src/modules/acadia/documents/actions";
import { modifiedWorkDocumentsList } from "src/modules/acadia/documents/selectors";
import { DocumentsWithApproversTypeRecord } from "src/modules/modules.type";
import { DrawerComponent, Modal } from "src/components/DialogComponent";
import Form from "src/components/Form";
import moment from "moment";
import {
  addItemRequest,
  deleteItemRequest,
  getItemsRequest,
  updateItemRequest,
} from "src/modules/spItems/api";
import AlertIcon from "src/components/ui-icons/table/AlertIcon";
import { Pencil } from "src/components/ui-icons/card";
import Trash from "src/components/ui-icons/buttons/Trash";
import { addUsers } from "src/modules/users/actions";
import _ from "lodash";
import { emailAPI } from "src/utils/api.utils";

const { sendEmail } = emailAPI();

const folderNavigationItems: ListItem = {
  name: "Удалить из избранного",
  to: "/",
};

const FAVORITE_FOLDER_COUNT_PAGE_SIZE = 500;

function buildFavoriteFolderDocumentFilters(folder: FoldersType) {
  const filters = (Object.keys(folder) as Keys[]).reduce((acc, key) => {
    const value = folder[key];

    if (value) {
      acc[keyMap[key]] = value.id;
    }

    return acc;
  }, {} as Record<string, number>);

  return { ...filters, Status: [8, 3] };
}

function isRequestAborted(error: unknown) {
  if (!error || typeof error !== "object") return false;

  const aborted = error as { code?: string; name?: string };

  return (
    aborted.code === "ERR_CANCELED" ||
    aborted.name === "CanceledError" ||
    aborted.name === "AbortError"
  );
}


export function MainPageBreadcrumbLayout() {
  const { id } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const navItem: NavItemType | undefined = getNavigation(id).find(
    (n) => n.url === pathname
  );

  if (!navItem) {
    navigate("/");
    return null;
  }

  return <Breadcrumbs items={[{ name: navItem.name as string, url: navItem.url }]} />;
}

const MainPage = () => {
  const [showReplaceModal, setShowReplaceModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [fields, setFields] = useState([
    {
      type: "peoplePicker",
      require: true,
      single: true,
      key: "WhoReplaced",
      title: "Кому передать полномочия на согласование",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },
    {
      type: "dateRange",
      require: true,
      key: "ReplacePeriod",
      title: "Период передачи полномочий",
      placeholder: "дд.мм.гггг",
      minDate: new Date(),
      width: "w-full",
    },
  ]);
  const [defaultValues, setDefaultValues] = useState<any>({});
  const currentUser = useAppSelector(selectCurrentUser);
  const [customLoading, setCustomLoading] = useState(false);
  const [rightsReplaced, setRightsReplaced] = useState(false);
  const [whoReplaced, setWhoReplaced] = useState<any>(null);
  const [whomReplaced, setWhomReplaced] = useState<any>(null);
  const [busyFlag, setBusyFlag] = useState(false);
  const navigate = useNavigate();
  const [edit, setEdit] = useState(false);
  const [remove, setRemove] = useState(false);
  const dispatch = useAppDispatch();
  const users: any = useAppSelector(selectUsers);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      setCustomLoading(true);
      const sendData = {
        WhoReplaced: (formData as any).WhoReplaced[0]["value"].toLowerCase().trim(),
        WhomReplaced: currentUser.email,
        StartReplace:
          (typeof (formData as any).ReplacePeriod.startDate === "string" &&
            new Date((formData as any).ReplacePeriod.startDate)) ||
          (formData as any).ReplacePeriod.startDate,
        EndReplace:
          (typeof (formData as any).ReplacePeriod.endDate === "string" &&
            new Date((formData as any).ReplacePeriod.endDate)) ||
          (formData as any).ReplacePeriod.endDate,
      };
      const emailBody = {
        Body: `Здравствуйте ${users[(formData as any).WhoReplaced[0]["value"].toLowerCase().trim()] &&
          users[(formData as any).WhoReplaced[0]["value"].toLowerCase().trim()][
          "displayName"
          ]
          },<br/><br/>${currentUser["displayName"]
          } предоставил(а) Вам права на согласование документов на время своего отсутствия с ${moment(
            (formData as any).ReplacePeriod.startDate
          ).format("DD.MM.YYYY")} по ${moment(
            (formData as any).ReplacePeriod.endDate
          ).format(
            "DD.MM.YYYY"
          )}.<br/><br/>На главной странице помимо новых согласований Вам будет доступно согласование ранее созданных документов.`,
        DateToBeSentAt: moment(new Date())
          .clone()
          .subtract(12, "hours")
          .toDate(),
        Title:
          "Мои Документы | Права на согласование документов на время отсутствия",
        Subject:
          "Мои Документы | Права на согласование документов на время отсутствия",
        Recepients: (formData as any).WhoReplaced[0]["value"].toLowerCase().trim(),
        RepeatAt: 0,
      };
      getItemsRequest({
        listName: ReplacedListName,
        filters: { WhoReplaced: (formData as any).WhoReplaced[0]["id"] },
      }).then((results) => {
        if (results.items.length > 0) {
          setCustomLoading(false);
          setBusyFlag(true);
        } else {
          if (!edit) {
            addItemRequest({ listName: ReplacedListName, body: sendData }).then(
              () => {
                setCustomLoading(false);
                setShowReplaceModal(false);
                sendEmail(emailBody);
                navigate(0);
              }
            );
          } else {
            (sendData as any)["ID"] = (whomReplaced as any).ID;
            updateItemRequest({
              listName: ReplacedListName,
              body: sendData,
            }).then(() => {
              setCustomLoading(false);
              setShowReplaceModal(false);
              sendEmail(emailBody);
              navigate(0);
            });
          }
        }
      });
    }
  }, [formData]);

  useEffect(() => {
    setCustomLoading(true);
    if (currentUser && Object.keys(currentUser).length > 0 && currentUser.id) {
      getItemsRequest({
        listName: ReplacedListName,
        filters: { EndReplace: { end: moment().toISOString() } },
      }).then((results) => {
        const removeItems = [...results.items];
        const removeItemsIds = removeItems.map((item) => {
          return { ID: item.ID };
        });
        deleteItemRequest({
          listName: ReplacedListName,
          ID: 0,
          Ids: removeItemsIds,
        }).then(() => {
          getItemsRequest({
            listName: ReplacedListName,
            filters: { WhoReplaced: currentUser.id },
          }).then((results) => {
            setWhoReplaced(
              (results.items.length > 0 && results.items[0]) || null
            );
            getItemsRequest({
              listName: ReplacedListName,
              filters: { WhomReplaced: currentUser.id },
            }).then((results) => {
              setWhomReplaced(
                (results.items.length > 0 && results.items[0]) || null
              );
              setCustomLoading(false);
            });
          });
        });
      });
    }
  }, [currentUser]);

  useEffect(() => {
    if (whomReplaced || whoReplaced) {
      let emails: string[] = [];
      if (whomReplaced) {
        emails = [...emails, whomReplaced.WhoReplaced.get_email()];
        emails = [...emails, whomReplaced.WhomReplaced.get_email()];
      }
      if (whoReplaced) {
        emails = [...emails, whoReplaced.WhoReplaced.get_email()];
        emails = [...emails, whoReplaced.WhomReplaced.get_email()];
      }
      dispatch(addUsers(_.uniqWith(emails, _.isEqual)));
      setRightsReplaced(true);
    }
  }, [whoReplaced, whomReplaced]);

  useEffect(() => {
    if (edit) {
      setDefaultValues({
        WhoReplaced: [
          {
            label: users[whomReplaced.WhoReplaced.get_email()]["displayName"],
            value: whomReplaced.WhoReplaced.get_email(),
            avatar: null,
            email: whomReplaced.WhoReplaced.get_email(),
          },
        ],
        ReplacePeriod: {
          startDate: whomReplaced.StartReplace,
          endDate: whomReplaced.EndReplace,
        },
      });
      setShowReplaceModal(true);
    }
  }, [edit]);

  useEffect(() => {
    if (!showReplaceModal) {
      setEdit(false);
    }
  }, [showReplaceModal]);

  const removeHandle = () => {
    setCustomLoading(true);
    deleteItemRequest({ listName: ReplacedListName, ID: whomReplaced.ID }).then(
      () => {
        setCustomLoading(false);
        setRemove(false);
        navigate(0);
      }
    );
  };

  return (
    <>
      <div className="py-4">
        <MainPageBreadcrumbLayout />
      </div>
      <div>
        <WorkDocuments
          setShowReplaceModal={setShowReplaceModal}
          rightsReplaced={rightsReplaced}
          setRightsReplaced={setRightsReplaced}
          whomReplaced={whomReplaced} //Меня кто-то замещает
          whoReplaced={whoReplaced} //Кого-то замещаю я
          customLoading={customLoading}
          setEdit={setEdit}
          setRemove={setRemove}
        />
        <section className="mb-7.5">
          <h3 className="text-[#637381] font-medium mb-3">Избранное</h3>
          <FavoriteFolders />
          <FavoriteFilters />
          <FavoriteTable />
        </section>
      </div>
      <Modal
        zIndex={70}
        modalClassName="min-h-px flex gap-5 p-10 max-w-[600px]"
        open={showReplaceModal}
        toggleDialog={setShowReplaceModal}
      >
        {(customLoading && (
          <>
            <h2>Передаём полономочия...</h2>
            <Loading />
          </>
        )) || (
            <>
              {(busyFlag && (
                <>
                  <h2>Ошибка</h2>
                  <p>Пользователь уже занят</p>
                  <FlexRow className="justify-between items-center w-full">
                    <TGButton
                      onClick={() => {
                        setBusyFlag(false);
                      }}
                      color="white"
                    >
                      Отмена
                    </TGButton>
                  </FlexRow>
                </>
              )) || (
                  <>
                    <h2>Передать полномочия на согласование</h2>

                    <Form
                      type="approvers_replaced"
                      setFormData={setFormData}
                      fieldsForm={fields}
                      defaultValues={defaultValues}
                      setOpenCancelAddCard={setShowReplaceModal}
                      openCancelAddCard={showReplaceModal}
                    />
                  </>
                )}
            </>
          )}
      </Modal>
      <Modal
        zIndex={70}
        modalClassName="min-h-px flex gap-5 p-10 max-w-[600px]"
        open={remove}
        toggleDialog={setRemove}
      >
        {(customLoading && (
          <>
            <h2>Подождите...</h2>
            <Loading />
          </>
        )) || (
            <>
              <h2 className="mb-10">
                Вы уверены, что хотите отозвать/ приостановить права согласования
                у заместителя
              </h2>
              <FlexRow className="justify-between items-center w-full">
                <TGButton onClick={() => setRemove(false)} color="white">
                  Отмена
                </TGButton>
                <TGButton onClick={() => removeHandle()} color="bluedark">
                  Подтвердить
                </TGButton>
              </FlexRow>
            </>
          )}
      </Modal>
    </>
  );
};

export default MainPage;

function WorkDocuments(props: any) {
  const {
    setShowReplaceModal,
    rightsReplaced,
    setRightsReplaced,
    whomReplaced,
    whoReplaced,
    customLoading,
    setEdit,
    setRemove,
  } = props;
  const data = useAppSelector(
    (state) => state.spitems.elements.obj.MyWorksDocuments
  );
  const nextPage = useAppSelector((state) =>
    selectNextPage(state, myWorksDocumentsListName)
  );
  const dispatch = useAppDispatch();

  const user = useAppSelector(selectCurrentUser);
  const [documents, setDocuments] = useState<MyWorkDocumentsType[]>([]);

  const [page, setPage] = useState(1);
  const users: any = useAppSelector(selectUsers);

  useLayoutEffect(() => {
    if (nextPage === null && page !== 1) {
      setPage(1);
    }
  }, []);

  useEffect(() => {
    async function fetchData() {
      if (data && Object.keys(data).length > 0) {
        const myDocuments = await modifiedWorkDocumentsList(
          data as DocumentsWithApproversTypeRecord[]
        );

        setDocuments(myDocuments);
      } else {
        setDocuments([]);
      }
    }

    fetchData();
  }, [data, user.id]);

  useEffect(() => {
    async function fetchData() {
      if (page === 1 || nextPage === null) {
        dispatch(
          getWorkDocumentsInfo({
            listName: myWorksDocumentsListName,
          })
        );
      } else {
        dispatch(
          getWorkDocumentsInfo({
            listName: myWorksDocumentsListName,
            nextPage: nextPage,
            merge: true,
          })
        );
      }
    }

    if (user.id) {
      fetchData();
    }
  }, [dispatch, page, user.id]);

  // useEffect(() => {
  //   if (status === "SUCCESS") {
  //     dispatch(getItemsIdle({ listName: myWorksDocumentsListName }));
  //   }
  // }, [dispatch, status]);

  type ApprovedStatusMock = "Утвержден" | "Отклонен" | "Ожидание";

  return (
    <section className="mb-7.5">
      <FlexRow className="justify-between items-center mb-4">
        <h3 className="text-[16px]">
          Мои документы в работе · {documents.length}
        </h3>
        {/*{!rightsReplaced && !customLoading && (*/}
        {/*  <TGButton onClick={() => setShowReplaceModal(true)} color="bluedark">*/}
        {/*    Передать полномочия на согласование*/}
        {/*  </TGButton>*/}
        {/*)}*/}
      </FlexRow>
      {rightsReplaced && (
        <FlexRow className="mb-3 w-full">
          <FlexCol className="p-9 w-full bg-white rounded-lg shadow-custom">
            <FlexRow className="justify-between items-center w-full">
              <FlexRow className="gap-5">
                <AlertIcon />
                <FlexCol>
                  <h3 className="text-[#00629B] mb-3">
                    Переданы полномочия на согласование
                  </h3>
                  {whomReplaced && (
                    <p>
                      В период с{" "}
                      {moment(whomReplaced.StartReplace).format("DD.MM.YYYY")}{" "}
                      по {moment(whomReplaced.EndReplace).format("DD.MM.YYYY")}{" "}
                      ответственный за согласование{" "}
                      {users[whomReplaced.WhoReplaced?.get_email()] &&
                        users[whomReplaced.WhoReplaced?.get_email()][
                        "displayName"
                        ]}
                    </p>
                  )}
                  {whoReplaced && (
                    <p>
                      В период с{" "}
                      {moment(whoReplaced.StartReplace).format("DD.MM.YYYY")} по{" "}
                      {moment(whoReplaced.EndReplace).format("DD.MM.YYYY")} вы
                      отвечаете за согласование. Полномочия передал:{" "}
                      {users[whoReplaced.WhomReplaced.get_email()] &&
                        users[whoReplaced.WhomReplaced.get_email()][
                        "displayName"
                        ]}
                    </p>
                  )}
                </FlexCol>
              </FlexRow>
              {whomReplaced && (
                <FlexRow className="gap-4 items-center">
                  <FlexCol
                    onClick={(e) => setEdit(true)}
                    className="cursor-pointer"
                  >
                    <Pencil hover={true} />
                  </FlexCol>
                  <FlexCol
                    onClick={(e) => setRemove(true)}
                    className="text-[#9CA3AF] hover:text-[#012169] cursor-pointer"
                  >
                    <Trash />
                  </FlexCol>
                </FlexRow>
              )}
            </FlexRow>
          </FlexCol>
        </FlexRow>
      )}
      <WorksDocumentTable documents={documents} />
      {!!nextPage && (
        <TGButton onClick={() => setPage((prev) => prev + 1)} color="bluedark">
          Подгрузить еще документы
        </TGButton>
      )}
    </section>
  );
}

function FavoriteFolders() {
  const { id: queryId } = useParams();

  const dispatch = useAppDispatch();

  const user = useAppSelector((state) => selectCurrentUser(state));

  const deleted = useAppSelector((state) =>
    selectJustDeletedItem(state, favoriteFoldersListName)
  );

  const { updateFolders, clearFolders } = useFoldersContext();
  const { resetFilters } = useFiltersContext();
  const navigate = useNavigate();

  let { data, status } = useGetSelect(favoriteFoldersListName);

  let folders = useMemo(() => modifiedFavoriteFoldersList(data), [data]);

  function removeFavoriteFolder(folderId: number) {
    dispatch(
      deleteItem({
        listName: favoriteFoldersListName,
        ID: folderId,
      })
    );
  }

  function chooseFolder(folder: FoldersType) {
    resetFilters();
    clearFolders();
    if (folder) {
      updateFolders(folder);
      setLocalItem("filter_active", "folder");
      setDocNavIntent({ type: "folder" });
      navigate(`/dashboard/${queryId}/documents`);
    }
  }

  useEffect(() => {
    if (user.id) {
      dispatch(
        getItems({
          listName: favoriteFoldersListName,
          filters: { Author: user.id },
          // viewFields: Object.keys(listFields[favoriteFoldersListName]),
        })
      );
    }
  }, [dispatch, user, deleted]);

  if (status === "LOADING" && !user.email) return <Loading />;

  return (
    <div className="grid grid-cols-1 gap-2 mb-5 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6">
      {folders.map((folder, i) => (
        <FavoriteFolderCard
          key={folder.id}
          folder={folder}
          menuPosition={(i + 1) % 6 ? "left" : "right"}
          onChoose={chooseFolder}
          onRemove={removeFavoriteFolder}
        />
      ))}
    </div>
  );
}

function FavoriteFolderCard({
  folder,
  menuPosition,
  onChoose,
  onRemove,
}: {
  folder: Folder;
  menuPosition: string;
  onChoose: (folder: FoldersType) => void;
  onRemove: (folderId: number) => void;
}) {
  const [count, setCount] = useState<number | null>(null);
  const [counting, setCounting] = useState(true);
  const folderFiltersKey = JSON.stringify(folder.folder);

  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    const filters = buildFavoriteFolderDocumentFilters(JSON.parse(folderFiltersKey));

    async function countDocuments() {
      setCounting(true);
      setCount(null);

      let total = 0;
      let nextPage: number | null = null;
      let pages = 0;

      try {
        do {
          if (!active || controller.signal.aborted) return;

          const response: { items: unknown[]; nextPage: number | null } = await getItemsRequest({
            listName: myDocumentsListName,
            filters,
            sortOrder: { name: "ID", asc: true },
            rowLimit: FAVORITE_FOLDER_COUNT_PAGE_SIZE,
            nextPage,
            viewFields: ["ID"],
            populateFields: ["Collection"],
            switchViewFields: true,
            signal: controller.signal,
          });

          if (!active || controller.signal.aborted) return;

          total += response.items.length;

          const upcomingPage = response.nextPage;
          nextPage = upcomingPage && upcomingPage !== nextPage ? upcomingPage : null;
          pages += 1;
        } while (nextPage && pages < 1000 && active);

        if (active) {
          setCount(total);
          setCounting(false);
        }
      } catch (error) {
        if (!active || controller.signal.aborted || isRequestAborted(error)) return;

        console.error("ошибка подсчета документов избранной папки", error);

        if (active) {
          setCount(null);
          setCounting(false);
        }
      }
    }

    countDocuments();

    return () => {
      active = false;
      controller.abort();
    };
  }, [folder.id, folderFiltersKey]);

  return (
    <div className="flex relative cursor-pointer group card">
      <FlexRow
        onClick={() => onChoose(folder.folder)}
        className="h-[120px] w-full justify-center border border-[#DFE4EA] bg-white rounded-lg"
      >
        <FlexCol className="p-4 grow">
          <FlexRow className="justify-between items-center space-x-2">
            <FlexCol className="flex flex-col">
              <FolderIcon />
            </FlexCol>
            <FlexCol className="flex-1 opacity-0 transition-all duration-300 group-hover:opacity-100">
              <span
                className="text-[14px] font-medium text-black line-clamp-1"
                title={folder.title}
              >
                {folder.title}
              </span>
            </FlexCol>
          </FlexRow>
          <FlexRow className="relative pt-3">
            <FlexCol className="transition-all duration-300 grow group-hover:opacity-0">
              <FlexRow className="text-[14px] font-medium text-[#637381] line-clamp-1">
                {folder.title}
              </FlexRow>
              <FlexRow className="mt-2">
                <p className="flex items-center gap-2">
                  {counting ? (
                    <>
                      <span className="inline-block w-3 h-3 rounded-full border-2 border-[#637381] border-t-transparent animate-spin" />
                      Идет подсчет
                    </>
                  ) : count === null ? (
                    "Не удалось посчитать"
                  ) : count ? (
                    `${count} ${pluralizeDocument(count, "документ")}`
                  ) : (
                    "Нет документов"
                  )}
                </p>
              </FlexRow>
            </FlexCol>
            <FlexCol
              className="absolute z-0 flex-1 transition-all duration-300 opacity-0 group-hover:z-[1] group-hover:opacity-100 line-clamp-3"
              title={getTitleByObject(folder.folder).join("/")}
            >
              <p>{getTitleByObject(folder.folder).join("/")}</p>
            </FlexCol>
          </FlexRow>
        </FlexCol>
      </FlexRow>
      <div className="absolute items-start justify-start z-20 top-2.5 right-2.5">
        <MenuButton
          onClick={() => onRemove(folder.id)}
          item={folderNavigationItems}
          position={menuPosition}
        >
          <DotsIcon />
        </MenuButton>
      </div>
    </div>
  );
}


function FavoriteFilters() {
  const { id: queryId } = useParams();

  const user = useAppSelector((state) => selectCurrentUser(state));

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { clearFolders } = useFoldersContext();
  const { resetFilters, updateFilter } = useFiltersContext();

  const { data, status } = useGetSelect(favoriteFiltersListName);

  let filters = useMemo(
    () => modifiedFavoriteFiltersList(data),
    [JSON.stringify(data)]
  );

  function chooseFilter(filter: Filter) {
    resetFilters();
    clearFolders();
    if (filter) {
      updateFilter(filter.filter);

      setLocalItem("filter_active", "filter");
      setDocNavIntent({ type: "filter", favoriteId: filter.id });
      navigate(`/dashboard/${queryId}/documents`);
    }
  }

  useEffect(() => {
    if (user.id) {
      dispatch(
        getItems({
          listName: favoriteFiltersListName,
          filters: { Author: user.id, Type: "doc" },
          viewFields: Object.keys(listFields[favoriteFiltersListName]),
        })
      );
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (status === "SUCCESS") {
      dispatch(getItemsIdle({ listName: favoriteFiltersListName }));
    }
  }, [status, dispatch]);

  if (status === "LOADING" && !user.email) return <Loading />;

  return (
    <div>
      {filters.length > 0 ? (
        <FlexCol className="gap-2 mb-5 w-full">
          {filters.map((fav) => (
            <FlexCol className="w-full" key={fav.id}>
              <FlexRow
                onClick={() => chooseFilter(fav)}
                className="items-center px-5 py-2.5 rounded-lg border border-[#DFE4EA] bg-white gap-x-2 select-none cursor-pointer w-full"
              >
                <FlexCol>
                  <StarIcon fill="orange" stroke="orange" className="w-6 h-6" />
                </FlexCol>
                <FlexCol className="font-medium text-[#637381]">
                  {fav.title}
                </FlexCol>
              </FlexRow>
            </FlexCol>
          ))}
        </FlexCol>
      ) : null}
    </div>
  );
}

function MenuButton({
  item,
  position,
  onClick,
  children,
}: {
  item: ListItem;
  position: string;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <Menu as="div" className="flex relative z-10 items-center">
      {({ open }) => (
        <div className="relative">
          <Menu.Button
            className={twMerge(
              open ? "button-state-active" : "",
              "flex relative justify-center items-center rounded-lg menu-button button-state"
            )}
          >
            {children}
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              className={twMerge(
                position === "left" ? "-left-5" : "-right-5",
                "absolute top-[calc(100%+5px)] whitespace-nowrap z-10 w-fit py-2.5 origin-top-right bg-white rounded-md shadow-custom ring-1 ring-black ring-opacity-5 focus:outline-none"
              )}
            >
              <Menu.Item>
                <button
                  onClick={onClick}
                  className={
                    "hover:bg-[#F5F7FD] hover:text-darkblue block px-5 py-2 text-gray-700"
                  }
                >
                  {item.name}
                </button>
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </div>
      )}
    </Menu>
  );
}
